import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getPeopleRecords,
  updateLeadStatus,
  exportPeopleList,
} from "../../../apis/profileApi";
import { sendMessage } from "../../../apis/messagesApi";
import type {
  ExportPeopleFilterType,
  LeadStatusType,
  PeopleType,
  SendMessageType,
} from "../types";

export function useGetPeopleRecords(peopleType: PeopleType) {
  return useQuery({
    queryKey: ["peopleRecords", peopleType],
    queryFn: () => getPeopleRecords(peopleType),
  });
}

export function useUpdateLeadStatus() {
  return useMutation({
    mutationFn: (payload: { userUuid: string; leadStatus: LeadStatusType }) =>
      updateLeadStatus(payload.userUuid, payload.leadStatus),
  });
}

export function useSendMessage() {
  return useMutation({
    mutationFn: (payload: SendMessageType) => sendMessage(payload),
  });
}

export function useExportPeopleList(
  peopleType: PeopleType,
  userUuids?: string[],
  filters?: ExportPeopleFilterType,
) {
  return useQuery({
    enabled: false, // Disable the query by default
    queryKey: ["exportPeople", peopleType, userUuids, filters],
    queryFn: () => exportPeopleList(peopleType, userUuids, filters),
  });
}
